import React, { useState, useEffect, createContext, useRef, useContext } from "react";
import { format } from "date-fns";
import '../../../css/BillScreen.css';
import { AlertContext, UserContext } from "../../../App";
import axios from "axios";
import { API } from "../../../services/api";

axios.defaults.baseURL = API;

function BillScreen() {

    function getDate(gdate) {
        var date = new Date(gdate);
        return format(date, "dd-MM-yyyy HH:mm");
    }

    const {showAlert, setShowAlert, errorMessage, setErrorMessage} = useContext(AlertContext);
    const {userID, LocationID, showForm, setShowForm, setshowSubmenu} = useContext(UserContext);
    const [TemOrderList, setTemOrderList] = useState([]);
    const [subTotal, setSubTotal] = useState(0);
    const [NetTotal, setNetTotal] = useState(0);
    const [Tax, setTax] = useState(0);
    const [PaidAmount, setPaidAmount] = useState(0);
    const [PaidMoreAmount, setPaidMoreAmount] = useState(0);
    const [DiscountAmount, setDiscountAmount] = useState(0);
    const [ChangeAmount, setChangeAmount] = useState(0);

    function currencyFormat(num) {
        if (num !== "") {
            return Number(num).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        }
    }

    async function getTemOrder () {
        let TemOrderForViewScreen = localStorage.getItem("TemOrderForViewScreen");
        setDiscountAmount(localStorage.getItem("DiscountAmount"));
        if(localStorage.getItem("PaidAmount") > 0){
            setPaidAmount(localStorage.getItem("PaidAmount"));
            setChangeAmount(localStorage.getItem("ChangeAmount"));
        } else {
            setPaidAmount(0);
            setChangeAmount(0);
        }
        
        if (TemOrderForViewScreen) {
            let TempOrder = JSON.parse(TemOrderForViewScreen);
            setTemOrderList(TempOrder);
        } else {
            setTemOrderList([]);
        }
    }

    const handleclickBack = () => {
      setShowForm(false);
      setshowSubmenu(true);
    };

    const getSubtotal = () => {
        if (TemOrderList) {
          if(TemOrderList.length > 0){
                var gSubTotal = 0;
                for (var i=0; i < TemOrderList.length; i++) {
                    gSubTotal = Number(gSubTotal) + Number(TemOrderList[i].SubTotal);
                }  
                var gNewTax = 0;
                var gtax =  gSubTotal * (10 / 100);
                var roundUp = gtax.toString().substr(-3, 3);
                if(roundUp > 500){
                    gNewTax = (Number(gtax) - Number(roundUp)) + 1000;
                } else if(roundUp < 500) {
                    gNewTax = (Number(gtax) - Number(roundUp));
                } else {
                    gNewTax = gtax;
                }
                setTax(gNewTax);
                setSubTotal(gSubTotal);
                setNetTotal(gSubTotal + gNewTax);
            } else{
                setSubTotal(0);
                setNetTotal(0);
                setTax(0);
            }
        } else{
            setSubTotal(0);
            setNetTotal(0);
            setTax(0);
        }
    }

    useEffect(() => {
        const interval = setInterval(() => {
          getTemOrder();
          getSubtotal();
        }, 100); //set your time here. repeat every 5 seconds
      
        return () => clearInterval(interval);
      }, [TemOrderList]);

    return (
        <div className="BillScreenForm">
            <div className="BillScreenHeader">
                <div className="imglogo">
                    <img className="logo" src="https://firebasestorage.googleapis.com/v0/b/maneecafe-e8ef3.appspot.com/o/images%2FManeeCafeLogo.jpg?alt=media&token=be4159bc-3c38-41c4-9c57-634457c3868c" />
                </div>
                <span>MANEE ARABICA COFFEE</span>
                <div className="buttonContent">
              <button className="btn btn-danger" onClick={() => handleclickBack()} >X</button>
          </div>
            </div>
                <div className="BillScreenLeftContent">
                    <div className="BillScreenOrderHead">
                        <div className="ProductName">Price / Item</div>
                        <div className="Quantity">Quantity</div>
                        <div className="Price">Total</div>
                    </div>
                    <div className="BillScreenOrderBody">
                        {
                            TemOrderList && TemOrderList.map((x, y) => {
                                return (
                                    <div key={y} className="orderContent">
                                        <div className="orderFooter">
                                            <div className="price">
                                                <p>{currencyFormat(x.Retail_Price)}</p>
                                            </div>
                                            <div className="quantity">
                                                <p>{currencyFormat(x.Quantity)}</p>
                                            </div>
                                            <div className="Subtotal">
                                                <p>{currencyFormat(x.Quantity * x.Retail_Price)}</p>
                                            </div>
                                        </div>
                                        <div className="orderBody">
                                            <div className="detail">
                                                <div className="productName">
                                                    <span>{y+1}. {x.LaoName} {x.Sugar} %</span>         
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>

                <div className="BillScreenRightContent">
                    <div className="BillScreenRightContentBody">
                    <div className="subtotal">
                        <span>Subtotal:</span>
                        <strong>{currencyFormat(subTotal)}</strong>
                    </div>
                    <div className="discout">
                        <span>Discount:</span>
                        <strong>{currencyFormat(DiscountAmount) || '0'}</strong>
                    </div>
                    <div className="tax">
                        <span>Tax:</span>
                        <strong>{currencyFormat(Tax) || '0'}</strong>
                    </div>
                    <div className="nettotal">
                        <span>NetTotal:</span>
                        <strong>{currencyFormat(NetTotal - DiscountAmount) || '0'}</strong>
                    </div>
                    <div className="billScreenfooter-line"></div>
                    <div className="paidAmount">
                        <span>PaidAmount:</span>
                        <strong>{currencyFormat(PaidAmount) || '0'}</strong>
                    </div>
                    <div className="changeAmount">
                        <span>ChangeAmount:</span>
                        <strong>{currencyFormat(ChangeAmount) || '0'}</strong>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default BillScreen;
